import { useRef } from "react";
import { Grid } from '@mui/material';
import SuppressionBuilder from "./suppressionBuilder";
import _ from 'lodash';

const lookupFields = {
	"poc.cell": { label: "Is cellphone", type: "boolean" },
	"poc.consent": { label: "Has consent", type: "boolean" },
	"poc.writtenConsent": { label: "Date of written consent", type: "date" },
	"poc.optOut": { label: "Has opted out", type: "boolean" },
	"poc.preferred": { label: "Is preferred", type: "boolean" },
	"poc.thirdParty": { label: "Is third party", type: "boolean" }
};

const condensedFields = Object.keys(lookupFields).map(x => ({
	name: x,
	label: lookupFields[x].label
}));

export default function PocSuppression({ formikProps, checkIndex, tenant }) {

	const pocPath = `checks.${checkIndex}.pocQuerySuppression`;
	const pocQuerySuppression = formikProps.values.checks[checkIndex].pocQuerySuppression;

	function processFilterArray(items, combinator, isBase = true) {
		const ruleArray = [];
		const ruleGroup = { [combinator]: ruleArray };

		for (const item of items) {
			ruleArray.push(processFilterItem(item, items.combinator));
		}

		if (isBase) {
			return {
				and: [
					{ tenant: { eq: tenant } },
					{ contact: { eq: "CONTACTIDPLACEHOLDER" } },
					{ field: { eq: "FIELDPLACEHOLDER" } },
					ruleGroup
				]
			};
		} else {
			return ruleGroup;
		}
	}

	function processFilterItem(item) {
		const cpyItem = { ...item };

		// field-level rule
		if (item.field) {
			if (
				cpyItem.value === true || cpyItem.value === false ||
				cpyItem.value === "true" || cpyItem.value === "false"
			) {
				cpyItem.value = String(cpyItem.value) === "true";
			} else if (!isNaN(cpyItem.value)) {
				cpyItem.value = +cpyItem.value;
			} else if (!!Date.parse(cpyItem.value)) {
				cpyItem.value = Date.parse(cpyItem.value);
			}

			return { [`${cpyItem.field}`]: { [cpyItem.operator]: cpyItem.value } };
		}

		// group rule
		return processFilterArray(cpyItem.rules, cpyItem.combinator, false);
	}

	function handleQueryChange(query) {
		// update rawQuery
		formikProps.setFieldValue(`${pocPath}.rawQuery`, query);

		// update structured query
		const formatted = processFilterArray(
			query.rules,
			query.combinator ?? "AND"
		);

		formikProps.setFieldValue(`${pocPath}.query`, formatted);
	}

	function getType(field) {
		return lookupFields[field].type;
	}

	function getValues(field) {
		return lookupFields[field].values;
	}

	function getOperators(field) {
		switch (lookupFields[field].type) {
			case "boolean":
			default:
				return [
					{ name: "eq", label: "=" },
					{ name: "ne", label: "!=" }
				];
			case "date":
				return [
					{ name: "lt", label: "<" },
					{ name: "gt", label: ">" },
					{ name: "lte", label: "<=" },
					{ name: "gte", label: ">=" }
				];
		}
	}

	return (
		<Grid container spacing={2} direction="column">
			<Grid item>
				<SuppressionBuilder
					query={pocQuerySuppression.rawQuery}
					onQueryChange={handleQueryChange}
					showCombinatorsBetweenRules
					fields={condensedFields}
					getValueEditorType={getType}
					getInputType={getType}
					getValues={getValues}
					getOperators={getOperators}
				/>
			</Grid>
		</Grid>
	);
}
